export { default } from './PageTypesSection'
